<template>
    <vx-dropdown placement="right">
        <vx-button
            type="button"
            color="muted"
            outline
            class="w-[45px]"
            data-test="segment-actions"
            aria-label="Segment actions"
        >
            <font-awesome-icon widthAuto :icon="faEllipsis" />
        </vx-button>

        <template v-slot:items>
            <router-dropdown-item
                v-if="!props.segment.is_template && !props.segment.group_id && !props.segment.org_unit_id"
                :to="{ name: 'segments.contacts', params: { segmentId: props.segment.id } }"
            >
                View Contacts
                <font-awesome-icon widthAuto :icon="faAddressBook"></font-awesome-icon>
            </router-dropdown-item>

            <segment-row-export
                v-if="!props.segment.is_template && !props.segment.group_id && !props.segment.org_unit_id"
                :segmentId="props.segment.id"
            ></segment-row-export>
            <vx-dropdown-item v-if="isStatic" @click="refreshSegment()">
                Refresh
                <font-awesome-icon widthAuto :icon="faArrowsRotate"></font-awesome-icon>
            </vx-dropdown-item>
            <router-dropdown-item :to="duplicateRoute" data-test="segment-duplicate-action">
                Duplicate
                <font-awesome-icon widthAuto :icon="faCopy"></font-awesome-icon>
            </router-dropdown-item>
            <vx-dropdown-item @click="deleteSegment()">
                Delete
                <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
            </vx-dropdown-item>
        </template>
    </vx-dropdown>
</template>

<script setup>
import { faAddressBook, faArrowsRotate, faCopy, faEllipsis, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxDropdown, VxDropdownItem, VxSwal } from '@voxie/frontend-components';
import { useToasted } from '../../../composables/useToasted';
import { segmentsClient } from '~/services';
import { SegmentType } from '../../../constants/segment';
import { computed } from 'vue';
import SegmentRowExport from './SegmentRowExport.vue';
import RouterDropdownItem from '~/components/general/RouterDropdownItem.vue';
import { throwSwalRequestError } from '~/utils/request';

const isStatic = computed(() => props.segment.type === SegmentType.STATIC);
const toasted = useToasted();

const props = defineProps({
    segment: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['deleted']);

const duplicateRoute = computed(() => ({
    name: props.segment.is_template ? 'segments.templates.new' : 'segments.new',
    query: { duplicateFromId: props.segment.id },
}));

const refreshSegment = async () => {
    try {
        await segmentsClient.refreshSegment({ teamId: props.segment.team_id }, props.segment.id);

        toasted.success('Segment refresh started successfully.');
    } catch (error) {
        console.error(error);
        toasted.global.platform_error();
    }
};

const deleteSegment = () => {
    VxSwal.confirmation(
        'Delete Segment',
        'Are you sure? This segment and its association to contacts will be deleted. There is no undo.',
        'danger',
        () =>
            segmentsClient
                .deleteSegment(
                    {
                        teamId: props.segment.team_id,
                        orgUnitId: props.segment.org_unit_id,
                        groupId: props.segment.group_id,
                    },
                    props.segment.id
                )
                .then(() => emit('deleted', props.segment.id))
                .catch(throwSwalRequestError)
    );
};
</script>
